import React from 'react';
import styled, { css } from 'styled-components';
import ScrollableAnchor, { configureAnchors } from 'react-scrollable-anchor';

import { Box, Flex, Paragraph } from './UIKit/system';
import Container from './container';
import GridCol from './grid-col';
import Title from './title';
import LinkWithArrow from './link-with-arrow';
import mq from '../utils/mq';
import LazyImage from './lazy-image';
import { getFluidGatsbyImage } from '../utils/gatsby-storyblok-image-fixed';

const StyledItem = styled.div`
  border-bottom: 2px #f3f3f3 solid;
  ${(props) =>
    props.lastItem &&
    css`
      border-bottom: 0px;
    `};
  padding-bottom: 20px;
  margin-bottom: 20px;
  &:last-of-type {
    margin-bottom: 0;
  }
`;

const StyledSectionVacanciesInnerContainer = styled(Flex)`
  padding-top: 102px;
  padding-bottom: 133px;
  ${mq.mobile(css`
    padding-top: 64px;
    padding-bottom: 64px;
    flex-wrap: wrap;
  `)};
`;

const TitleContainer = styled(GridCol)`
  ${mq.mobile(css`
    width: 100%;
    margin-bottom: 26px;
  `)};
`;

const AssetContainer = styled.div`
  width: 100%;
  height: auto;
  aspect-ratio: 3/2;
  overflow: hidden;
  position: relative;
  background-color: #f8f8f8;
  margin-top: 46px;
  border-radius: 16px;
  overflow: hidden;
  ${mq.mobile(css`
    margin-top: 24px;
  `)};
`;

const StyledParagraph = styled(Paragraph)`
  margin-bottom: 64px;
  ${mq.mobile(css`
    margin-bottom: 42px;
  `)};
`;

function Item({ title, link, lastItem }) {
  return (
    <StyledItem lastItem={lastItem}>
      <LinkWithArrow to={link} fontSizeLarge reverse spread smallIcon>
        {title}
      </LinkWithArrow>
    </StyledItem>
  );
}

const StyledSectionVacancies = styled(Box)``;

function SectionVacancies({ title, paragraph, items, asset }) {
  configureAnchors({ offset: -100, scrollDuration: 200 });
  return (
    <ScrollableAnchor id={'careers'}>
      <StyledSectionVacancies>
        <Container>
          <StyledSectionVacanciesInnerContainer>
            <TitleContainer>
              <Title fontSize={[28, 28, 38, 42]}>{title}</Title>
              {asset && asset?.filename && (
                <AssetContainer>
                  <LazyImage
                    fluid={getFluidGatsbyImage(asset)}
                    width="100%"
                    height="100%"
                    style={{
                      width: '100%',
                      height: '100%',
                      objectFit: 'cover'
                    }}
                  />
                </AssetContainer>
              )}
            </TitleContainer>
            <Box>
              <StyledParagraph color={'#666666'} html={paragraph} />

              {items &&
                items.map((item, index) => {
                  if (index === items.length - 1) {
                    return <Item key={index} {...item} lastItem />;
                  } else {
                    return <Item key={index} {...item} />;
                  }
                })}
            </Box>
          </StyledSectionVacanciesInnerContainer>
        </Container>
      </StyledSectionVacancies>
    </ScrollableAnchor>
  );
}

export default SectionVacancies;
